import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, TransitRequestWFSteps, TransitConfirmVesselEntranceDecision, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { ConfirmVesselEntranceComponent } from '../confirm-vessel-entrance/confirm-vessel-entrance.component';
import { Router } from '@angular/router';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';

@Component({
  selector: 'app-navigation-decision',
  templateUrl: './navigation-decision.component.html'
})
export class NavigationDecisionComponent {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitRequestWFSteps.NavigationDecision;
  navigationDecisionForm: FormGroup;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest;
  displayedLang: string;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  isLoaded: boolean = false;
  @ViewChild('ConfirmVesselEntrance', { static: false }) ConfirmVesselEntrance: ConfirmVesselEntranceComponent;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  stepHistoryId: any;
  stepData: any;
  requestStatuses: number[];

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private router: Router,
  ) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      // this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.navigationDecisionForm = this.formBuilder.group({
      NavigationNotes: ['', Validators.required],
    });
  }

  get f() { return this.navigationDecisionForm.controls; }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        this.isLoaded = true;
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistoryById();
        } else if (!this.requestStatuses.includes(ServiceStatus.Transit_PendingNavigationDecision)) {
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistory();
        }
      }
    )
  }

  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, this.stepId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }
    );
  }

  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }
    );
  }

  getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.navigationDecisionForm.patchValue({
      NavigationNotes: this.stepData.NavigationNotes
    });
    this.navigationDecisionForm.disable();
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.navigationDecisionForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.navigationDecisionForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.ConfirmVesselEntrance.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;



    this.transitService.SubmitNavigationDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.navigationDecisionForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
